import { useCallback } from 'react';
import { useNavigate } from 'react-router';

import { type LoggingContext } from '#packages/data-collection/types/logging-context';

export const useNavigateReload = ({ logger }: LoggingContext) => {
  const navigate = useNavigate();

  const navigateReload = useCallback(() => {
    logger?.debug('Reloading the current page');

    navigate(0);
  }, [navigate]);

  return navigateReload;
};
